<p-dialog
  [visible]="visible() && showDialog()"
  (onHide)="closeChargeOnTerminalModal()"
  [resizable]="false"
  appendTo="body"
  [modal]="true"
  [breakpoints]="{ '767px': '100vw' }"
  [style]="{ width: '470px' }"
  styleClass="no-header-modal overflow-visible"
  aria-label="charge-on-terminal-dialog"
  data-testid="charge-on-terminal-dialog">
  <ng-template pTemplate="header" styleClass="hidden" />
  <ng-template pTemplate="content" styleClass="p-0">
    <div
      class="surface-0 p-3 sticky left-0 top-0 w-full z-1 flex align-items-center justify-content-between border-bottom-1 border-300"
      data-testid="dialog-header">
      <h2 class="mb-0 text-sm line-height-1">
        {{ 'POS_DEVICE.CHARGE_ON_POS' | translate }}
      </h2>
      <button
        type="button"
        class="fa fa-times text-xl text-600 cursor-pointer border-none bg-transparent p-0"
        (click)="closeChargeOnTerminalModal()"
        aria-label="close-dialog"
        data-testid="close-dialog-button"></button>
    </div>

    <form [formGroup]="deviceForm" data-testid="device-form">
      <div class="surface-100 px-3" data-testid="device-list-container">
        @if (loading) {
          <div class="py-3">
            @for (item of [1, 2]; track item) {
              <p-skeleton height="4rem" styleClass="mb-3" />
            }
          </div>
        } @else {
          <ul class="list-none p-0 m-0 text-sm">
            @for (device of terminals; track device.id) {
              <li
                class="my-3 border-1 border-primary hover:border-primary border-round surface-0 p-3 cursor-pointer"
                (click)="selectDevice(device)"
                (keydown.enter)="selectDevice(device)"
                (keydown.space)="$event.preventDefault(); selectDevice(device)"
                tabindex="0"
                role="radio"
                [attr.aria-checked]="isDeviceSelected(device)"
                [attr.aria-label]="'select-device-' + device.terminal_name"
                [attr.data-testid]="'device-item-' + device.id">
                <div class="flex align-items-center">
                  <div class="w-2rem">
                    <img
                      width="20"
                      src="assets/img/icons/icon-terminal.svg"
                      alt="Terminal Icon"
                      data-testid="terminal-icon" />
                  </div>
                  <h6
                    class="text-sm mb-0 text-primary"
                    [attr.data-testid]="'device-name-' + device.terminal_name">
                    {{ device.terminal_name }}
                  </h6>
                </div>
                <div class="flex justify-content-between align-items-center">
                  <ul class="list-none text-600 ml-4 pl-2 mb-0">
                    <li [attr.data-testid]="'device-gateway-' + device.id">
                      {{ 'POS_DEVICE.PAYMENT_GATEWAY' | translate }}
                      <strong>{{ device.pgw_enum_id }}</strong>
                    </li>
                    <li [attr.data-testid]="'device-terminal-id-' + device.id">
                      {{ 'POS_DEVICE.TERMINAL_ID' | translate }}
                      <strong>{{ device.terminal_id }}</strong>
                    </li>
                  </ul>
                  <p-radioButton
                    [inputId]="'terminal-' + device.id"
                    [value]="device"
                    formControlName="selectedDevice"
                    [attr.aria-label]="'select-device-' + device.terminal_name"
                    [attr.data-testid]="'select-device-' + device.terminal_name" />
                </div>
              </li>
            }
          </ul>
        }
      </div>

      <div
        class="p-3 sticky left-0 bottom-0 w-full z-1 border-top-1 border-300 flex align-items-center justify-content-between"
        data-testid="dialog-footer">
        <p-button
          type="button"
          (onClick)="closePosDevice()"
          [label]="'common.BUTTONS.CANCEL-BUTTON-TEXT' | translate"
          styleClass="p-button-link text-sm"
          aria-label="cancel"
          data-testid="cancel-device-selection-button" />
        <p-button
          type="button"
          (onClick)="selectPosDevice()"
          [label]="'common.BUTTONS.BUTTON-TEXT-SAVE' | translate"
          [disabled]="!deviceForm.valid || loading"
          styleClass="text-sm"
          aria-label="save-device-selection"
          data-testid="save-device-selection-button" />
      </div>
    </form>
  </ng-template>
</p-dialog>
